import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useSendBroadcast = () => {
  const { token, user } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation(
    async (messageContent) => {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/messages/send-to-all`,
        { messageContent, sender: user?.userId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('adminMessages');
      },
    }
  );
};

export default useSendBroadcast;
